var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CChartLine',{staticClass:"panel-layout-chart",attrs:{"datasets":_vm.datasets,"labels":_vm.labels,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }